import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';


export default function Waiting(props: WaitingProps)
{
  return <Stack>
    <Typography variant="h5" paragraph={true}>
      Checking session..
      <CircularProgress />
    </Typography>
    <Skeleton variant="rectangular" height={120} />
  </Stack>;
}


interface WaitingProps
{
  message: string;
}
